/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_AudioInputs */

const en_dialog_text_to_audio = /** @type {(inputs: Dialog_Text_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Audio`)
};

const es_dialog_text_to_audio = /** @type {(inputs: Dialog_Text_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a audio`)
};

/**
* | output |
* | --- |
* | "Text to Audio" |
*
* @param {Dialog_Text_To_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio = /** @type {((inputs?: Dialog_Text_To_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio(inputs)
	return en_dialog_text_to_audio(inputs)
});